<div>
  <div class="d-flex align-items-center justify-content-between m-b-16 p-x-20 p-t-16">
    <h3>
      <span *ngIf="isEditMode">Editar Item</span>
      <span *ngIf="!isEditMode">Agregar Item</span>
    </h3>
    <button mat-icon-button (click)="onCancel()" class="d-flex justify-content-center">
      <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
  </div>

<mat-dialog-content>
  <form [formGroup]="itemForm">
    <!-- Item Details -->
    <div class="row mb-3">
      <div class="col-12">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Descripción *</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput formControlName="description" placeholder="Descripción del item">
          <mat-error *ngIf="itemForm.get('description')?.hasError('required')">
            La descripción es requerida
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-lg-4">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Cantidad *</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput type="number" formControlName="quantity" min="0.01" step="0.01">
          <mat-error *ngIf="itemForm.get('quantity')?.hasError('required')">
            La cantidad es requerida
          </mat-error>
          <mat-error *ngIf="itemForm.get('quantity')?.hasError('min')">
            La cantidad debe ser mayor a 0
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-lg-4">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Precio Final *</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput type="number" formControlName="unitPrice" min="0" step="0.01" placeholder="Precio con IVA incluido">
          <span matPrefix>$&nbsp;</span>
          <mat-error *ngIf="itemForm.get('unitPrice')?.hasError('required')">
            El precio final es requerido
          </mat-error>
          <mat-error *ngIf="itemForm.get('unitPrice')?.hasError('min')">
            El precio final debe ser mayor o igual a 0
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Impuestos: campo libre (sin catálogo configurado) -->
      <div class="col-lg-4" *ngIf="hasFreeTaxInput">
        <mat-label class="f-s-14 f-w-600 m-b-8 d-block">Impuesto %</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <input matInput type="number" formControlName="taxRate" min="0" max="100" step="0.01">
          <span matSuffix>%</span>
        </mat-form-field>
      </div>
    </div>

    <mat-divider class="mb-3"></mat-divider>

    <!-- Totals -->
    <div class="d-flex justify-content-end mb-3">
      <div class="item-totals-panel">
                 <div class="d-flex justify-content-between align-items-center mb-2">
                   <span class="f-s-14">Subtotal:</span>
                   <span class="f-s-14">${{ itemForm.get('subtotal')?.value | number:'1.2-2':'es-AR' }}</span>
                 </div>
                 <ng-container *ngIf="previewLineTaxes.length; else singleTaxRow">
                   <div *ngFor="let t of previewLineTaxes" class="d-flex justify-content-between align-items-center mb-2">
                     <span class="f-s-14">{{ t.taxName }}:</span>
                     <span class="f-s-14">${{ t.taxAmount | number:'1.2-2':'es-AR' }}</span>
                   </div>
                 </ng-container>
                 <ng-template #singleTaxRow>
                   <div class="d-flex justify-content-between align-items-center mb-2" *ngIf="itemForm.get('taxAmount')?.value">
                     <span class="f-s-14">Impuestos:</span>
                     <span class="f-s-14">${{ itemForm.get('taxAmount')?.value | number:'1.2-2':'es-AR' }}</span>
                   </div>
                 </ng-template>
                 <mat-divider class="my-2"></mat-divider>
                 <div class="d-flex justify-content-between align-items-center">
                   <strong class="f-s-16 text-primary">TOTAL:</strong>
                   <strong class="f-s-16 text-primary">${{ itemForm.get('total')?.value | number:'1.2-2':'es-AR' }}</strong>
                 </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<!-- Action Buttons -->
<div class="d-flex mt-3 button-container">
  <button
    mat-flat-button
    color="primary"
    (click)="onSubmit()"
    [disabled]="loading || itemForm.invalid"
    class="action-button"
  >
    <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
    <mat-icon *ngIf="!loading">save</mat-icon>
    <span>{{ loading ? 'Procesando...' : (isEditMode ? 'Actualizar Item' : 'Agregar Item') }}</span>
  </button>
  <button
    mat-flat-button
    class="m-l-8 bg-error text-white action-button"
    (click)="onCancel()"
    [disabled]="loading"
  >
    Cancelar
  </button>
</div>
